/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cra_Modal_TitleInputs */

const en_cra_modal_title = /** @type {(inputs: Cra_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refused access at the site`)
};

const ja_cra_modal_title = /** @type {(inputs: Cra_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現場でアクセス拒否`)
};

const fr_cra_modal_title = /** @type {(inputs: Cra_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès refusé sur site`)
};

const de_cra_modal_title = /** @type {(inputs: Cra_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugang vor Ort verweigert`)
};

/**
* | output |
* | --- |
* | "Refused access at the site" |
*
* @param {Cra_Modal_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cra_modal_title = /** @type {((inputs?: Cra_Modal_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cra_Modal_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cra_modal_title(inputs)
	if (locale === "ja") return ja_cra_modal_title(inputs)
	if (locale === "fr") return fr_cra_modal_title(inputs)
	return de_cra_modal_title(inputs)
});